import axios from 'axios';
import api from '@src/api';
import cloneDeep from 'lodash/cloneDeep';

export const state = {
  allEquipment: [],
  allEquipmentTrueSource: [],
  equipmentModel: null,
  equipmentDetails: {},
  selectedEquipment: null,
};

export const getters = {
  equipmentLabelMap: (state) => {
    const map = {};
    if (state.allEquipment) {
      state.allEquipment.forEach((equipment) => {
        map[equipment.label] = equipment;
      });
    }
    return map;
  },
  equipmentIdMap: (state) => {
    const map = {};
    if (state.allEquipment) {
      state.allEquipment.forEach((equipment) => {
        map[equipment._id] = equipment;
      });
    }
    return map;
  },
  equipmentTrainerMap: (state) => {
    const map = {};
    if (state.allEquipment) {
      state.allEquipment.forEach((equipment) => {
        if (!map[equipment.trainer_id]) {
          map[equipment.trainer_id] = [];
        }
        map[equipment.trainer_id].push(equipment);
      });
    }
    return map;
  },
};

export const mutations = {
  setAllEquipment(state, value) {
    state.allEquipment = value;
  },
  setAllEquipmentTrueSource(state, value) {
    state.allEquipmentTrueSource = value;
  },
  setCreateEquipment(state, value) {
    state.allEquipment.push(value);
    state.allEquipmentTrueSource.push(value);
  },
  setEquipmentDetails(state, value) {
    const clone = cloneDeep(state.equipmentDetails);
    clone[value.equipment._id] = value.equipment;
    state.equipmentDetails = clone;
  },
  setSelectedEquipment(state, value) {
    state.selectedEquipment = value;
  },
  setUpdateEquipmentItem(state, value) {
    const i = state.allEquipment.findIndex((item) => item._id === value._id);
    const equipmentsClone = cloneDeep(state.allEquipment);
    equipmentsClone[i] = value;
    state.allEquipment = equipmentsClone;

    const j = state.allEquipmentTrueSource.findIndex(
      (item) => item._id === value._id
    );
    const equipmentsCloneTrueSource = cloneDeep(state.allEquipmentTrueSource);
    equipmentsCloneTrueSource[j] = value;
    state.allEquipmentTrueSource = equipmentsCloneTrueSource;
  },
  setDeleteEquipmentItem(state, value) {
    const i = state.allEquipment.findIndex((item) => item._id === value._id);
    state.allEquipment.splice(i, 1);

    const j = state.allEquipmentTrueSource.findIndex(
      (item) => item._id === value._id
    );
    state.allEquipmentTrueSource.splice(j, 1);
  },
  setEquipmentModel(state, value) {
    state.equipmentModel = value;
  },
};

export const actions = {
  getAllEquipment(ctx, { orgId, trainerId }) {
    if (orgId !== undefined && trainerId !== undefined) {
      const url = api.URL_GET_ALL_EQUIPMENT.replace(':orgID', orgId).replace(
        ':trainerID',
        trainerId
      );

      return axios
        .get(url)
        .then((res) => {
          ctx.commit('setAllEquipment', res.data.equipments);
          ctx.commit('setAllEquipmentTrueSource', res.data.equipments);
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (orgId, trainerId) : (${orgId}, ${trainerId})`
      );
    }
  },

  getEquipment(ctx, { equipmentId, orgId, trainerId }) {
    if (
      equipmentId !== undefined &&
      orgId !== undefined &&
      trainerId !== undefined
    ) {
      if (!ctx.state.equipmentDetails[equipmentId]) {
        const url = api.URL_GET_EQUIPMENT.replace(':equipmentID', equipmentId)
          .replace(':orgID', orgId)
          .replace(':trainerID', trainerId);

        return axios
          .get(url)
          .then((res) => {
            if (res.data.success === false) {
              return res.data.error;
            } else {
              ctx.commit('setEquipmentDetails', res.data);
              return res.data;
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        return ctx.state.equipmentDetails[equipmentId];
      }
    } else {
      console.error(
        `invalid params (equipmentId, orgId, trainerId) : (${equipmentId}, ${orgId}, ${trainerId})`
      );
    }
  },

  createEquipment(ctx, { equipmentObj }) {
    if (isPayloadValid(equipmentObj)) {
      const url = api.URL_CREATE_EQUIPMENT.replace(
        ':equipmentID',
        equipmentObj._id
      )
        .replace(':orgID', equipmentObj.org_id)
        .replace(':trainerID', equipmentObj.trainer_id)
        .replace(':userID', equipmentObj.user_id);

      // Minimum data check for obj
      if (equipmentObj.label !== undefined) {
        const payload = { equipment: equipmentObj };
        return axios
          .put(url, payload)
          .then((res) => {
            ctx.commit('setCreateEquipment', res.data.equipment);
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'equipmentObj must contain the following properties to be a valid replacement [trainer_id, org_id, user_id, label, replace]',
          equipmentObj
        );
      }
    } else {
      logError(equipmentObj);
    }
  },

  updateEquipment(ctx, { equipmentObj }) {
    if (isPayloadValid(equipmentObj)) {
      const url = api.URL_UPDATE_EQUIPMENT.replace(
        ':equipmentID',
        equipmentObj._id
      )
        .replace(':orgID', equipmentObj.org_id)
        .replace(':trainerID', equipmentObj.trainer_id)
        .replace(':userID', equipmentObj.user_id);

      // Minimum data check for obj
      if (equipmentObj.label !== undefined) {
        const payload = { equipment: equipmentObj };
        return axios
          .post(url, payload)
          .then((res) => {
            ctx.commit('setUpdateEquipmentItem', res.data.equipment);
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'equipmentObj must contain the following properties to be a valid replacement [trainer_id, org_id, user_id, label, replace]',
          equipmentObj
        );
      }
    } else {
      logError(equipmentObj);
    }
  },

  deleteEquipment(ctx, { equipmentObj }) {
    if (isPayloadValid(equipmentObj)) {
      const url = api.URL_DELETE_EQUIPMENT.replace(
        ':equipmentID',
        equipmentObj._id
      )
        .replace(':orgID', equipmentObj.org_id)
        .replace(':trainerID', equipmentObj.trainer_id)
        .replace(':userID', equipmentObj.user_id);

      return axios
        .delete(url)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      logError(equipmentObj);
    }
  },

  getEquipmentShape(ctx, { orgId, trainerId, userId = 0 }) {
    if (orgId !== undefined && trainerId !== undefined) {
      const url = api.URL_GET_EQUIPMENT_SHAPE.replace(':orgID', orgId)
        .replace(':trainerID', trainerId)
        .replace(':userID', userId);

      return axios
        .get(url)
        .then((res) => {
          ctx.commit('setEquipmentModel', res.data.equipment);
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (orgId, trainerId) : (${orgId}, ${trainerId})`
      );
    }
  },
};

// Private Helpers

function isPayloadValid(obj) {
  // Minimum data check for payload
  return (
    obj !== undefined ||
    (obj.trainer_id !== undefined &&
      obj.org_id !== undefined &&
      obj.user_id !== undefined)
  );
}

function logError(equipmentObj) {
  console.error(
    `Invalid Params: (equipmentObj, trainer_id, org_id, user_id) : (${equipmentObj}, ${equipmentObj.trainer_id}, ${equipmentObj.org_id}, ${equipmentObj.user_id})`
  );
}
